export default {
  PLATFORM_FLOW_AB_TEST_BRANCH_ACTION: 'ab-test-branch',
  PLATFORM_FLOW_ADS_AUDIENCE_MEMBERSHIP_ACTION: 'ads-audience-membership',
  PLATFORM_FLOW_ALTER_LIST_MEMBERSHIP_ACTION: 'alter-list-membership',
  PLATFORM_FLOW_AUTOMATION_EXTENSION_ACTION: 'extension',
  PLATFORM_FLOW_CLASSIC_ANCHORED_DELAY_ACTION: 'classic-anchored-delay',
  PLATFORM_FLOW_CLASSIC_COPY_COMPANY_PROPERTY_ACTION: 'classic-copy-company-property',
  PLATFORM_FLOW_CLASSIC_ENROLL_IN_WORKFLOW_ACTION: 'classic-enroll-in-flow',
  PLATFORM_FLOW_CLASSIC_NOTIFICATION_EMAIL_ACTION: 'classic-notification-email',
  PLATFORM_FLOW_CLASSIC_VIRTUAL_ANCHORED_DELAY_ACTION: 'anchor-delay-details',
  PLATFORM_FLOW_CREATE_OBJECT_ACTION: 'create-object',
  PLATFORM_FLOW_CREATE_SALESFORCE_CAMPAIGN_ACTION: 'create-salesforce-campaign',
  PLATFORM_FLOW_CREATE_SALESFORCE_TASK_ACTION: 'create-salesforce-task',
  PLATFORM_FLOW_CUSTOM_CODE_ACTION: 'custom-code',
  PLATFORM_FLOW_DELAY_ACTION: 'delay',
  PLATFORM_FLOW_DELAY_UNTIL_DATE_ACTION: 'delay-until-date',
  PLATFORM_FLOW_EMAIL_ACTION: 'email',
  PLATFORM_FLOW_EMAIL_NOTIFICATION_ACTION: 'email-notification',
  PLATFORM_FLOW_ENROLL_IN_FLOW_ACTION: 'enroll-in-flow',
  PLATFORM_FLOW_FORMULA_ACTION: 'format-data',
  PLATFORM_FLOW_GO_TO_ACTION: 'go-to-edit',
  PLATFORM_FLOW_IN_APP_NOTIFICATION_ACTION: 'in-app-notification',
  PLATFORM_FLOW_LIST_BRANCH_ACTION: 'list-branch',
  PLATFORM_FLOW_ROTATE_OBJECT_ACTION: 'rotate-object',
  PLATFORM_FLOW_SEND_SMS_NOTIFICATION_ACTION: 'send-sms-notification',
  PLATFORM_FLOW_SET_PROPERTY_ACTION: 'set-property',
  PLATFORM_FLOW_SLACK_NOTIFICATION_ACTION: 'slack',
  PLATFORM_FLOW_STATIC_BRANCH_ACTION: 'static-branch',
  PLATFORM_FLOW_TASK_ACTION: 'task',
  PLATFORM_FLOW_VIRTUAL_SCHEDULED_ENROLLMENT: 'enrollment-schedule',
  PLATFORM_FLOW_WAIT_UNTIL_ACTION: 'delay-until',
  PLATFORM_FLOW_WEBHOOK_ACTION: 'webhook',
  PLATFORM_FLOW_WHILE_LOOP_ACTION: 'while-loop',
  PLATFORM_FLOW_ALL_BRANCHES_ACTION: 'branch',
  PLATFORM_FLOW_ALL_DELAYS_ACTION: 'all-delays'
};